import * as React from 'react'
import {PropsProvider} from '../../core/components/Tables/PropsProvider'
import {IFeatureLayerInfo, IQuery, ITableProps} from '../../core/interfaces/models'
import {Column, RowInfo} from 'react-table'
import AppReadOnlyEditSplitter from '../FeatureViews/AppReadOnlyEditSplitter'
import {IFeatureTablesDispatcher, IMapDispatcher} from '../../core/interfaces/dispatchers'

class AppPropsProvider extends PropsProvider {}

export const appPropsProvider = new AppPropsProvider()
